import api from '@shared/services/api';
import { User } from "@shared/types/user";
import { useUserMapStore } from '../store/userMapStore';

export async function buildUserMap(userProfileIds: string[], currentUser?: User): Promise<Record<string, User>> {
  const { fetchUsers } = useUserMapStore.getState();
  return fetchUsers(userProfileIds, currentUser);
}

export async function fetchGroupParticipantsUserMap(groupId: string): Promise<Record<string, User>> {
  const { addUsers, userMap } = useUserMapStore.getState();
  const res = await api.get(`/groups/${groupId}/participants`);
  const users: User[] = Array.isArray(res.data?.participants) ? res.data.participants : [];
  const map: Record<string, User> = {};
  users.forEach(user => { map[user.id] = user; });
  addUsers(map);
  return { ...userMap, ...map };
}
